import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService, NotificationCenterQuery, NotificationCenterService } from '@fgb/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'fgb-mobile-nav-menu',
  templateUrl: './mobile-nav-menu.component.html',
  styleUrls: ['./mobile-nav-menu.component.scss'],
  animations: [
    trigger('expandAnimation', [
      state('open', style({ transform: 'rotate(0deg)' })),
      state('close', style({ transform: 'rotate(180deg)' })),
      transition('open <=> close', [animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')]),
    ]),
  ],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  selectedMember: string;
  productcode = ProductCode;
  unseenNotificationCount$: Observable<number>;
  constructor(
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationCenterService,
    private notificationQuery: NotificationCenterQuery,
  ) {}
  private routerSubscription: Subscription;
  public isCollapsed = true;

  ngOnInit() {
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap(() => (this.isCollapsed = true))
      )
      .subscribe();
    this.unseenNotificationCount$ = this.notificationQuery.unseenNotificationsCount$;
  }
  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  logout() {
    this.authService
      .logout()
      .toPromise()
      .then(() => this.router.navigate(['/login']));
  }

  toggleNotificationCenter(open: boolean) {
    this.notificationService.updateIsOpen(open);
  }
}
